window.bcn = {};

bcn.init = function() {
    svg4everybody();
    autosize(document.querySelectorAll('textarea'));
    bcn.imageUploads.init();
    bcn.imageUploadLimit.init();
    bcn.wrapSelects.init();
    bcn.backings.init();
    bcn.events.init();
    bcn.modal.init();
    bcn.relation_picker.init();
    bcn.navigation.init();
    bcn.fixedNotice.init();
    bcn.cms.init();
    bcn.donate.init();
    bcn.tabs.init();
    bcn.chart.init();
    // bcn.readMore.init();
    bcn.closeStatusHeader.init();
    bcn.fauxLinks.init();
    bcn.scroll.init();
    bcn.dropDowns.init();
    bcn.characterLimit.init();
    bcn.datepicker.init();
    bcn.carousel.init();
    bcn.inputTypeNumber.init();
    bcn.inputEditedClass.init();
    bcn.togglePasswordFields.init();
    bcn.gtmDonation.init();
}

